import { EISGroupsInfo, ISelectableOption, GroupInfo } from "../../../../types";

export const getGLGroupIdOptions = ({
  groupIds,
  selectedGroupId,
  eisGroups,
}: {
  groupIds: string[];
  selectedGroupId: string;
  eisGroups: EISGroupsInfo;
}): ISelectableOption[] => {
  const uniqueGroupIds = [...new Set([...groupIds, selectedGroupId])];

  return uniqueGroupIds.flatMap((groupId) => {
    const group = eisGroups.groups.find(
      (group: GroupInfo) =>
        group.type === "GL_GROUP" && group.groupId === groupId,
    );

    if (!group) return [];

    return [
      {
        label: group.name,
        value: groupId,
      },
    ];
  });
};